// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 639 ? "benefits" : chunkId) + "." + {"44":"31d6cfe0","153":"5545c024","504":"fe56dab9","639":"e3124d61"}[chunkId] + ".chunk.css";
};